// Curated Mool Nanakshahi and major Sikh-history dates for calendar year 2026.
// Fixed dates follow the Nanakshahi reference linked below; lunar observances are
// explicitly scoped to 2026 and should be reviewed before being reused.
const source = 'https://sikhsinindia.com/pa/02-sikh-heritage/02-02-discover-culture/02-02-04-sikh-calendar.html';
const audience = 'Punjab / Sikh communities';

const sikhOccasions2026 = [
  ['2026-01-14', 'Maghi / Mela Maghi', 'Sikh festival'],
  ['2026-01-14', 'Forty Mukte Remembrance', 'Sikh history'],
  ['2026-01-20', 'Keys Morcha (Chabian Da Morcha) Remembrance', 'Sikh history'],
  ['2026-02-01', 'Bhagat Ravidas Ji Prakash Purab', 'Sikh / Bhagat tradition'],
  ['2026-02-07', 'Mela Kotha Sahib', 'Sikh history'],
  ['2026-02-09', 'Vadda Ghallughara Remembrance', 'Sikh history'],
  ['2026-02-12', 'Sahibzada Ajit Singh Ji Janam Diwas', 'Sikh history'],
  ['2026-02-21', 'Saka Nankana Sahib and Jaito Morcha Remembrance', 'Sikh history'],
  ['2026-03-04', 'Hola Mohalla', 'Sikh festival', '2026 lunar date'],
  ['2026-03-14', 'Nanakshahi New Year', 'Sikh festival'],
  ['2026-03-14', 'Gurgaddi Diwas Sri Guru Har Rai Sahib Ji', 'Gurpurab'],
  ['2026-03-15', 'Sardar Baghel Singh Delhi Fateh Diwas', 'Sikh history'],
  ['2026-03-19', 'Jyoti Jot Diwas Sri Guru Hargobind Sahib Ji', 'Gurpurab'],
  ['2026-03-25', 'Shaheedi Bhai Subeg Singh Ji and Bhai Shahbaz Singh Ji', 'Sikh history'],
  ['2026-04-09', 'Sahibzada Jujhar Singh Ji Janam Diwas', 'Sikh history'],
  ['2026-04-14', 'Khalsa Sajna Diwas / Vaisakhi', 'Sikh festival'],
  ['2026-04-14', 'Sri Guru Nanak Dev Ji Prakash Purab (Mool Nanakshahi)', 'Gurpurab'],
  ['2026-04-16', 'Jyoti Jot Diwas Sri Guru Angad Dev Ji', 'Gurpurab'],
  ['2026-04-16', 'Gurgaddi Diwas Sri Guru Amar Das Ji', 'Gurpurab'],
  ['2026-04-16', 'Jyoti Jot Diwas Sri Guru Har Krishan Sahib Ji', 'Gurpurab'],
  ['2026-04-16', 'Gurgaddi Diwas Sri Guru Tegh Bahadur Sahib Ji', 'Gurpurab'],
  ['2026-04-18', 'Sri Guru Angad Dev Ji Prakash Purab', 'Gurpurab'],
  ['2026-04-18', 'Sri Guru Tegh Bahadur Sahib Ji Prakash Purab', 'Gurpurab'],
  ['2026-05-02', 'Sri Guru Arjan Dev Ji Prakash Purab', 'Gurpurab'],
  ['2026-05-17', 'Chhota Ghallughara Remembrance', 'Sikh history'],
  ['2026-05-23', 'Sri Guru Amar Das Ji Prakash Purab', 'Gurpurab'],
  ['2026-06-04', 'June 1984 Ghallughara Remembrance', 'Sikh history'],
  ['2026-06-06', 'June 1984 Shaheedi Remembrance', 'Sikh history'],
  ['2026-06-11', 'Gurgaddi Diwas Sri Guru Hargobind Sahib Ji', 'Gurpurab'],
  ['2026-06-16', 'Shaheedi Diwas Sri Guru Arjan Dev Ji', 'Gurpurab'],
  ['2026-06-25', 'Shaheedi Baba Banda Singh Bahadur Ji', 'Sikh history'],
  ['2026-06-29', 'Maharaja Ranjit Singh Ji Barsi', 'Punjab / Sikh history'],
  ['2026-06-29', 'Bhagat Kabir Ji Janam Diwas', 'Sikh / Bhagat tradition', '2026 lunar date'],
  ['2026-07-05', 'Sri Guru Hargobind Sahib Ji Prakash Purab', 'Gurpurab'],
  ['2026-07-09', 'Shaheedi Bhai Mani Singh Ji', 'Sikh history'],
  ['2026-07-16', 'Shaheedi Bhai Taru Singh Ji', 'Sikh history'],
  ['2026-07-21', 'Miri-Piri Diwas', 'Sikh history'],
  ['2026-07-23', 'Sri Guru Har Krishan Sahib Ji Prakash Purab', 'Gurpurab'],
  ['2026-08-08', 'Guru Ka Bagh Morcha Remembrance', 'Sikh history'],
  ['2026-08-28', 'Mela Baba Bakala', 'Sikh history'],
  ['2026-09-01', 'Pehla Prakash Sri Guru Granth Sahib Ji', 'Gurpurab'],
  ['2026-09-12', 'Saragarhi Day', 'Punjab / Sikh history'],
  ['2026-09-16', 'Jyoti Jot Diwas Sri Guru Amar Das Ji', 'Gurpurab'],
  ['2026-09-16', 'Gurgaddi Diwas Sri Guru Ram Das Ji', 'Gurpurab'],
  ['2026-09-16', 'Jyoti Jot Diwas Sri Guru Ram Das Ji', 'Gurpurab'],
  ['2026-09-16', 'Gurgaddi Diwas Sri Guru Arjan Dev Ji', 'Gurpurab'],
  ['2026-09-18', 'Gurgaddi Diwas Sri Guru Angad Dev Ji', 'Gurpurab'],
  ['2026-09-22', 'Jyoti Jot Diwas Sri Guru Nanak Dev Ji', 'Gurpurab'],
  ['2026-10-01', 'Singh Sabha Movement Foundation Day', 'Sikh history'],
  ['2026-10-05', 'Mela Bir Baba Buddha Ji', 'Sikh history'],
  ['2026-10-09', 'Sri Guru Ram Das Ji Prakash Purab', 'Gurpurab'],
  ['2026-10-20', 'Jyoti Jot Diwas Sri Guru Har Rai Sahib Ji', 'Gurpurab'],
  ['2026-10-20', 'Gurgaddi Diwas Sri Guru Har Krishan Sahib Ji', 'Gurpurab'],
  ['2026-10-20', 'Gurgaddi Diwas Sri Guru Granth Sahib Ji', 'Gurpurab'],
  ['2026-10-21', 'Jyoti Jot Diwas Sri Guru Gobind Singh Sahib Ji', 'Gurpurab'],
  ['2026-10-22', 'Khalsa Darbar Remembrance', 'Sikh history'],
  ['2026-10-28', 'Chief Khalsa Diwan Foundation Day', 'Sikh history'],
  ['2026-10-28', 'Saka Panja Sahib Remembrance', 'Sikh history'],
  ['2026-11-01', 'Punjabi Suba Diwas', 'Punjab / Sikh history'],
  ['2026-11-08', 'Bandi Chhor Divas', 'Sikh festival', '2026 lunar date'],
  ['2026-11-13', 'Shaheedi Baba Deep Singh Ji', 'Sikh history'],
  ['2026-11-14', 'SGPC Foundation Day', 'Sikh history'],
  ['2026-11-20', 'Bhagat Namdev Ji Janam Diwas', 'Sikh / Bhagat tradition', '2026 lunar date'],
  ['2026-11-24', 'Sri Guru Nanak Dev Ji Prakash Gurpurab', 'Gurpurab', '2026 lunar date'],
  ['2026-11-24', 'Gurgaddi Diwas Sri Guru Gobind Singh Sahib Ji', 'Gurpurab'],
  ['2026-11-24', 'Shaheedi Diwas Sri Guru Tegh Bahadur Sahib Ji', 'Gurpurab'],
  ['2026-11-24', 'Shaheedi Bhai Mati Das Ji and Bhai Sati Das Ji', 'Sikh history'],
  ['2026-11-28', 'Sahibzada Zorawar Singh Ji Janam Diwas', 'Sikh history'],
  ['2026-12-02', 'Shaheedi Baba Gurbaksh Singh Ji', 'Sikh history'],
  ['2026-12-12', 'Sahibzada Fateh Singh Ji Janam Diwas', 'Sikh history'],
  ['2026-12-17', 'Shaheedi Baba Jiwan Singh Ji', 'Sikh history'],
  ['2026-12-23', 'Shaheedi Vadde Sahibzade', 'Sikh history'],
  ['2026-12-25', 'Sri Guru Gobind Singh Ji Prakash Purab (Mool Nanakshahi)', 'Gurpurab'],
  ['2026-12-26', 'Veer Bal Diwas', 'Sikh / national'],
  ['2026-12-28', 'Shaheedi Chhote Sahibzade and Mata Gujri Ji', 'Sikh history']
].map(([date, name, category, dateNote = 'Mool Nanakshahi date']) => [
  date, name, category, audience, dateNote, 'HIGH', source
]);

export default sikhOccasions2026;
